export function feedName(dataType, field, id) {
  if (!!id && !!id.id) {
    return feedName(dataType, field, id.id);
  }

  return [dataType, id, field].join('-');
}

export const feedsByType = {
  users: ['posts', 'replies', 'followers'],
  threads: ['messages'],
  groups: ['posts'],
};

const feedNaming = {};
Object.entries(feedsByType)
  .forEach(([type, names]) => {
    const result = {};
    names.forEach(name => result[name] = id => feedName(type, name, id));
    feedNaming[type] = result;
  });

export default feedNaming;



// WEBPACK FOOTER //
// ./~/virgo/src/utils/feedNaming.js